export const COOKIES_CONSENT = '/project/get/cookies/consentCookies';